import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// FormatDateTimePipe
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Pipe({
  name: 'formatDateTime'
})

export class FormatDateTimePipe implements PipeTransform {

    //==================================
    // transform
    //==================================
    transform(value) {
        return value ? moment(value).format("MM/DD/YYYY HH:mm:ss A") : "";
   }
}